$(function () {
  if (masterViewModel) {
    masterViewModel.start();
  }
})